<template>
  <div>
    <el-button type="text" @click="viewDetails">发货申请单</el-button>
    <el-form
      :model="formData"
      ref="ruleForm"
      :rules="rules"
      label-position="left"
      label-width="80px"
      size="default"
    >
      <div class="table-container">
        <el-row :gutter="20" justify="middle" align="center">
          <el-col :span="24">
            <div class="grid-content">出库单</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4"> <div class="grid-content">客户名称</div> </el-col>
          <el-col :span="12"
            ><div class="grid-content">
              <el-input
                v-model="formData.customerName"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="4"><div class="grid-content">开单日期</div></el-col>
          <el-col :span="4"
            ><div class="grid-content">
              <el-date-picker
                v-model="formData.billingDate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="2"> <div class="grid-content">序号</div> </el-col>
          <el-col :span="5"> <div class="grid-content">品名</div> </el-col>
          <el-col :span="3">
            <div class="grid-content">数量</div>
          </el-col>
          <el-col :span="3"> <div class="grid-content">单位</div> </el-col>
          <el-col :span="3"> <div class="grid-content">价格</div> </el-col>
          <el-col :span="3"> <div class="grid-content">货款</div> </el-col>
          <el-col :span="5">
            <div class="grid-content">备注</div>
          </el-col>
        </el-row>

        <el-row
          :gutter="20"
          v-for="(item, index) in formData.contentList"
          :key="item.id"
        >
          <el-col :span="2"
            ><div class="grid-content">
              {{ index + 1 }}
            </div></el-col
          >
          <el-col :span="5"
            ><div class="grid-content">
              <el-input
                v-model="item.categoryName"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="3"
            ><div class="grid-content">
              <el-input
                v-model="item.quantity"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="3"
            ><div class="grid-content">
              <el-input v-model="item.units" clearable="true"></el-input></div
          ></el-col>
          <el-col :span="3"
            ><div class="grid-content">
              <el-input
                v-model="item.unitPrice"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="3"
            ><div class="grid-content">
              <el-input
                v-model="item.paymentGoods"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="5"
            ><div class="grid-content">
              <el-input v-model="item.remark" clearable="true"></el-input></div
          ></el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="4"><div class="grid-content">合计</div></el-col>
          <el-col :span="4"
            ><div class="grid-content">
              <el-input
                v-model="formData.total"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="16"
            ><div class="grid-content">
              <p>
                物联卡机卡绑定，更换设备会锁卡，需联系客服解锁；请勿插在手机等移动端使用，经检测将被关停。
                本产品仅限于在规定的设备上使用，请勿用作他途
              </p>
            </div></el-col
          >
        </el-row>

        <el-row :gutter="20">
          <el-col :span="4"><div class="grid-content">备注</div></el-col>
          <el-col :span="20"
            ><div class="grid-content">
              <el-input
                v-model="formData.remark"
                clearable="true"
              ></el-input></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="3"><div class="grid-content">制单</div></el-col>
          <el-col :span="3"
            ><div class="grid-content">
              <el-input
                v-model="formData.documenter"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="3"><div class="grid-content">财务</div></el-col>
          <el-col :span="3"
            ><div class="grid-content">
              <el-input
                v-model="formData.financial"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="3"><div class="grid-content">仓库</div></el-col>
          <el-col :span="3"
            ><div class="grid-content">
              <el-input
                v-model="formData.entrepot"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="3"><div class="grid-content">客户签名</div></el-col>
          <el-col :span="3"
            ><div class="grid-content">
              <el-input
                v-model="formData.customerSignature"
                clearable="true"
              ></el-input></div
          ></el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>
<script>
import { historicActivityPerson } from "@/api/api.js"; //流程实例分页查询
import { processFromData } from "@/api/api.js"; //附加单据
export default {
  data() {
    return {
      formData: {
        id: undefined,
        customer_name: undefined,
        billing_date: undefined,
        remark: undefined,
        documenter: undefined,
        financial: undefined,
        entrepot: undefined,
        number: undefined,
        customer_signature: undefined,
        total: undefined,
        status: undefined,
        contentList: [
          {
            id: undefined,
            out_entrepot_id: undefined,
            category_name: undefined,
            quantity: undefined,
            units: undefined,
            unitPrice: undefined,
            payment_goods: undefined,
            remark: undefined,
          },
          {
            id: undefined,
            out_entrepot_id: undefined,
            category_name: undefined,
            quantity: undefined,
            units: undefined,
            unitPrice: undefined,
            payment_goods: undefined,
            remark: undefined,
          },
          {
            id: undefined,
            out_entrepot_id: undefined,
            category_name: undefined,
            quantity: undefined,
            units: undefined,
            unitPrice: undefined,
            payment_goods: undefined,
            remark: undefined,
          },
        ],
      },
      srcList: [
        "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg",
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      ],
      //   queryParams: {},
      //   tableData: [],
      //   page: 1,
      //   pageSize: 20,
      //   total: 0,
    };
  },
  props: {
    childId: {
      type: String,
    },
    childProcessId: {
      type: String,
    },
    fromType: {
      type: Number,
    },
  },
  methods: {
    // removeDomain(item) {
    //   var index = this.formData.contentList.indexOf(item);
    //   if (index !== -1) {
    //     this.formData.contentList.splice(index, 1);
    //   }
    // },
    // addDomain() {
    //   this.formData.contentList.push({
    //     key: Date.now,
    //     id: undefined,
    //     out_entrepot_id: undefined,
    //     category_name: undefined,
    //     quantity: undefined,
    //     units: undefined,
    //     unitPrice: undefined,
    //     payment_goods: undefined,
    //     remark: undefined,
    //   });
    // },
    // 获取列表的数据
    viewDetails() {
      this.$router.push({
        path: "/procedure/relevanceFrom",
        query: {
          id: this.childId,
          processId: this.childProcessId,
          fromType: this.fromType,
        },
      });
    },
    initData() {
      let params = {
        processInstanceId: this.childProcessId,
        taskId: this.childId,
      };
      //   processInstanceImage(params).then(res=>{
      //     this.str = res.data
      //   });
      processFromData(params).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.outEntrepot != undefined) {
            this.formData = res.data.data.outEntrepot;
          }
        }
      });
    },
    // 历史
    // editRow(id) {
    //   this.$router.push({ path: `/procedure/lcslHistory?id=${id}` });
    // },
    // 搜索
    // search() {
    //   (this.page = 1), this.initData();
    // },
    // 重置
    // resetForm() {
    //   for (var i in this.queryParams) {
    //     this.queryParams[i] = null;
    //   }
    //   this.initData();
    // },
    // handleSizeChange(pageSize) {
    //   this.pageSize = pageSize;
    //   this.initData();
    // },
    // handleCurrentChange(page) {
    //   this.page = page;
    //   this.initData();
    // },
  },
  mounted() {
    this.initData();
  },
  created() {},
};
</script>
<style scoped lang="less">
.el-row {
  //   margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 0px;
  //   min-height: 36px;
  border: 1px solid #4d4d4d;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 46px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}

.grid-content-image {
  border-radius: 4px;
  min-height: 300px;
  padding: 10px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

div.table-container {
  margin-top: 50px;
  margin-left: 220px;
  max-width: 1200px;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid black;
  table.table-layout {
    table-layout: fixed;
    border-collapse: collapse;
    width: 1080px;

    td.table-cell {
      display: table-cell;
      height: 36px;
      border: 1px solid black;
      text-align: center;
    }
  }
}
.table-checkbox,
.table-radio {
  display: table-cell;
  border: 1px solid black;
  text-align: left;
}

.add-button {
  margin-top: -340px;
  margin-right: -10px;
  float: right;
  position: relative;
}
.save {
  margin-top: 50px;
  margin-left: 750px;
  position: relative;
}
.text-input {
  width: 100%;
  height: 100%;
  padding: 5px;
  border: 1px #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  text-align: center;
}
.radio-input {
  vertical-align: middle;
  margin-top: -2px;
  margin-bottom: 1px;
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 138px;
  height: 138px;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.svg-avatar-uploader-icon {
  font-size: 28px;
  width: 60px;
  height: 60px;
  line-height: 18px;
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 138px;
  height: 138px;
  // line-height: 88px;
  text-align: center;
}
.avatar {
  width: 138px;
  height: 138px;
  display: block;
}
</style>


